<template>
    <slot></slot>

    <div class="flex items-center justify-center w-full">
        <div class="w-full max-w-[600px]">
            <label
                for="file"
                class="cursor-pointer text-xs text-gray-400 block mb-8 hover:text-gray-600 text-left"
                ><i class="fa-regular fa-paperclip mr-1 text-sm"></i>{{ label }}
            </label>
            <input
                id="file"
                accept=".pdf"
                class="hidden"
                href="#"
                type="file"
                @change="$emit('fileChanged', $event)"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
    defineProps<{
        file: File | undefined;
        label: string;
    }>();
    defineEmits<{
        (e: 'previous'): void;
        (e: 'fileChanged', $event: Event): void;
    }>();
</script>
